//variablen muessen pro instanz angepasst werden
module.exports = {
    mantelUrl : 'https://mantel-api.mobile.documedias.systems/v2/conferences/',
    baseUrl: 'https://mantel-api.mobile.documedias.systems/v2/checkall/',
    baseUrlDownload: 'https://mantel-api.mobile.documedias.systems/v2/downloadall/',
    baseUrlCDN: "https://documedias-188ab.kxcdn.com/",
    cdnInitStamp: "2025-08-25T10:48:33.808Z",
    conference: '1585',
    short_name: 'ispad2025',
    full_name: 'ISPAD 2025',
    api_version: 2, //change this to api version 2 for new conferences!!!
    conf_date : '27 – 29 October',
    api_url : 'https://coredev.api.documedias.systems/api/',
    appointment_api_url : 'https://dev.appointment.documedias.systems/api/',
    auth_url : 'https://auth.documedias.com/',
    auth_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozMDgwLCJjb25ncmVzc0lkIjoxNTg1LCJkYXRlIjoiMjAyNS0wOC0yMVQxMToxNjo1My44NDFaIiwiaWF0IjoxNzU1Nzc1MDEzfQ.hymO596jITT_dZII2hgJz2O1nvBoZbye6yJPSrsbERs',
    auth_dev_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozMDc5LCJjb25ncmVzc0lkIjoxNTg1LCJkYXRlIjoiMjAyNS0wOC0yMVQxMToxNjoyOS43MTdaIiwiaWF0IjoxNzU1Nzc0OTg5fQ.RhRwwVCPZBjBShzp0yPn4cIM7MC_nV1OaMXtIPuoMKs',
    vue_app_access_key : 'eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo5LCJjb25ncmVzc0lkIjoxLCJkYXRlIjoiMjAxOC0xMC0wMVQwOTo0Njo0MC42MDlaIiwiaWF0IjoxNTM4Mzg3MjAwfQ.1Z8vRJF2gZtCuLDEWxQhNyvlYHS6YZsdJxvoYGfyo112afY8CofuEBP4_jvIPXhc',
    chat_url: 'https://ispad2025.chat.documedias.systems/api/',
    is_app: false, //unbedingt anpassen bevor App deploy
    favorite_api_url: 'https://ispad2025.planner.documedias.systems/api/program/favorites',
    is_multi_conf_app: false //set true for society or Conf2Go

}
